module.exports = __webpack_public_path__ + "img/card-slider-rivoneed.24a9535e.webp";